(function (global, factory) {
  if (typeof module === "object" && module.exports) {
    module.exports = function (window, document) {
      return factory(window, document, true);
    };
  } else {
    factory(global, global.document, false);
  }
})(typeof window !== "undefined" ? window : this, function (window, document, commonJS) {
  "use strict";

  var GLOBAL_NAME = "NINTEProductGalleryLoaderV1";
  var ROOT_SELECTOR = '[data-product-gallery-loader="v1"]';
  var MAX_ACTIVE = 2;
  var DIAGNOSTIC_LIMIT = 5;
  var states = [];
  var diagnosticCount = 0;

  if (window[GLOBAL_NAME]) {
    window[GLOBAL_NAME].boot(document);
    return window[GLOBAL_NAME];
  }

  function createState(root) {
    return {
      root: root,
      destroyed: false,
      activeCount: 0,
      requests: [],
      readyKeys: [],
      pendingDemand: null,
      pendingWarmup: null,
      priorityTotal: 0,
      prioritySettled: 0,
      primaryReady: false,
      priorityKeys: [],
      priorityCleanups: [],
      customerInteracted: false,
      observer: null,
      clickHandler: null,
      jqueryBound: false,
      jqueryRetryCount: 0,
      jqueryRetryTimer: null,
      warmupKind: null,
      warmupHandle: null
    };
  }

  function forEach(nodes, callback) {
    Array.prototype.forEach.call(nodes, callback);
  }

  function setState(image, state, loaded) {
    image.setAttribute("data-gallery-state", state);
    image.setAttribute("data-gallery-loaded", loaded ? "true" : "false");
  }

  function sourceKey(src, srcset, sizes) {
    return [src, srcset || "", sizes || ""].join("\n");
  }

  function imageSource(image) {
    var src = image.getAttribute("data-gallery-src");
    var srcset = image.getAttribute("data-gallery-srcset");
    var sizes = image.getAttribute("sizes") || "";
    if (!src) return null;
    return { src: src, srcset: srcset || "", sizes: sizes, key: sourceKey(src, srcset, sizes) };
  }

  function collectWaiters(state, key) {
    var waiters = [];
    forEach(state.root.querySelectorAll("[data-gallery-image]"), function (image) {
      var source = imageSource(image);
      if (source && source.key === key && waiters.indexOf(image) === -1) waiters.push(image);
    });
    return waiters;
  }

  function jobForImage(state, image, intent) {
    var source = imageSource(image);
    if (!source) {
      setState(image, "error", false);
      reportDiagnostic("missing-source");
      return null;
    }
    return {
      key: source.key,
      src: source.src,
      srcset: source.srcset,
      sizes: source.sizes,
      intent: intent,
      waiters: collectWaiters(state, source.key)
    };
  }

  function mergeOrReplace(current, next) {
    if (!current || current.key !== next.key) return next;
    forEach(next.waiters, function (image) {
      if (current.waiters.indexOf(image) === -1) current.waiters.push(image);
    });
    return current;
  }

  function sameImageSource(image, job) {
    var current = imageSource(image);
    return !!(current && job && current.key === job.key);
  }

  function swapReadyImage(image, job) {
    if (!sameImageSource(image, job)) return false;
    if (job.srcset) image.setAttribute("srcset", job.srcset);
    image.setAttribute("src", job.src);
    setState(image, "ready", true);
    return true;
  }

  function isReadyKey(state, key) {
    return state.readyKeys.indexOf(key) !== -1;
  }

  function applyReadyKey(state, job) {
    job.waiters = collectWaiters(state, job.key);
    forEach(job.waiters, function (image) { swapReadyImage(image, job); });
  }

  function findRequest(state, key) {
    var match = null;
    forEach(state.requests, function (request) {
      if (!request.done && request.key === key) match = request;
    });
    return match;
  }

  function waitForPriority(state, job) {
    if (state.priorityKeys.indexOf(job.key) === -1) return false;
    forEach(job.waiters, function (image) {
      image.setAttribute("loading", "eager");
      setState(image, "requested", false);
    });
    return true;
  }

  function attachToRequest(state, job) {
    var request = findRequest(state, job.key);
    if (!request) return false;
    forEach(job.waiters, function (image) {
      if (request.waiters.indexOf(image) === -1) request.waiters.push(image);
      image.setAttribute("loading", "eager");
      setState(image, "requested", false);
    });
    return true;
  }

  function reportDiagnostic(code) {
    if (diagnosticCount >= DIAGNOSTIC_LIMIT) return;
    diagnosticCount += 1;
    if (window.console && typeof window.console.warn === "function") {
      window.console.warn.call(window.console, "[ninte-gallery-v1] " + code);
    }
  }

  function cancelWarmup(state) {
    if (state.warmupHandle !== null) {
      if (state.warmupKind === "idle" && typeof window.cancelIdleCallback === "function") {
        window.cancelIdleCallback(state.warmupHandle);
      } else {
        window.clearTimeout(state.warmupHandle);
      }
    }
    state.warmupHandle = null;
    state.warmupKind = null;
    state.pendingWarmup = null;
  }

  function requestImage(state, image, intent) {
    var job;
    if (state.destroyed || !image) return;
    job = jobForImage(state, image, intent);
    if (!job) return;
    if (intent === "demand") cancelWarmup(state);
    if (isReadyKey(state, job.key)) {
      applyReadyKey(state, job);
      return;
    }
    if (waitForPriority(state, job)) return;
    if (attachToRequest(state, job)) return;
    if (state.activeCount < MAX_ACTIVE) {
      startJob(state, job);
      return;
    }
    if (intent === "demand") {
      state.pendingDemand = mergeOrReplace(state.pendingDemand, job);
    } else if (!state.pendingDemand) {
      state.pendingWarmup = mergeOrReplace(state.pendingWarmup, job);
    }
  }

  function drain(state) {
    var job;
    if (state.destroyed || state.activeCount >= MAX_ACTIVE) return;
    job = state.pendingDemand;
    if (job) {
      state.pendingDemand = null;
      startJob(state, job);
      return drain(state);
    }
    job = state.pendingWarmup;
    if (job) {
      state.pendingWarmup = null;
      startJob(state, job);
    }
  }

  function settleDecode(image, ready, failed) {
    var result;
    if (typeof image.decode !== "function") return ready();
    try { result = image.decode(); } catch (error) { return failed(); }
    if (!result || typeof result.then !== "function") return failed();
    result.then(ready, failed);
  }

  function removeRequest(state, request) {
    var index = state.requests.indexOf(request);
    if (index !== -1) state.requests.splice(index, 1);
  }

  function settleRequest(state, request, success, code) {
    if (request.done) return;
    request.done = true;
    removeRequest(state, request);
    state.activeCount = Math.max(0, state.activeCount - 1);
    if (state.destroyed) {
      request.waiters = [];
      return;
    }
    if (success) {
      if (state.readyKeys.indexOf(request.key) === -1) state.readyKeys.push(request.key);
      applyReadyKey(state, request);
    } else {
      forEach(request.waiters, function (image) { setState(image, "error", false); });
      reportDiagnostic(code);
    }
    drain(state);
  }

  function startJob(state, job) {
    var preloader;
    var request;
    if (state.destroyed || state.activeCount >= MAX_ACTIVE) return;
    preloader = new window.Image();
    request = {
      done: false,
      key: job.key,
      src: job.src,
      srcset: job.srcset,
      sizes: job.sizes,
      waiters: job.waiters,
      preloader: preloader
    };
    state.requests.push(request);
    state.activeCount += 1;
    forEach(job.waiters, function (image) {
      image.setAttribute("loading", "eager");
      setState(image, "requested", false);
    });
    preloader.decoding = "async";
    preloader.onload = function () {
      settleDecode(
        preloader,
        function () { settleRequest(state, request, true, ""); },
        function () { settleRequest(state, request, false, "decode-failed"); }
      );
    };
    preloader.onerror = function () { settleRequest(state, request, false, "request-failed"); };
    if (job.sizes) preloader.sizes = job.sizes;
    if (job.srcset) preloader.srcset = job.srcset;
    preloader.src = job.src;
  }

  function hasSlickCloneAncestor(root, image) {
    var node = image && image.parentNode;
    while (node && node !== root) {
      if (node.classList && node.classList.contains("slick-cloned")) return true;
      node = node.parentNode;
    }
    return false;
  }

  function trackPriorityImages(state) {
    var images = [];
    forEach(state.root.querySelectorAll("[data-gallery-priority]"), function (image) {
      if (!hasSlickCloneAncestor(state.root, image)) images.push(image);
    });
    if (images.length > MAX_ACTIVE) {
      reportDiagnostic("priority-count-invalid");
      return false;
    }
    state.priorityTotal = images.length;
    forEach(images, function (image) {
      var source = imageSource(image);
      var settled = false;
      if (!source) {
        state.prioritySettled += 1;
        setState(image, "error", false);
        reportDiagnostic("missing-source");
        return;
      }
      state.activeCount += 1;
      if (source && state.priorityKeys.indexOf(source.key) === -1) state.priorityKeys.push(source.key);

      function finish(success, code) {
        var job;
        var keyIndex;
        if (settled || state.destroyed) return;
        settled = true;
        keyIndex = source ? state.priorityKeys.indexOf(source.key) : -1;
        if (keyIndex !== -1) state.priorityKeys.splice(keyIndex, 1);
        job = source ? {
          key: source.key,
          src: source.src,
          srcset: source.srcset,
          sizes: source.sizes,
          intent: "demand",
          waiters: collectWaiters(state, source.key)
        } : null;
        if (success && source) {
          if (state.readyKeys.indexOf(source.key) === -1) state.readyKeys.push(source.key);
          if (job) applyReadyKey(state, job);
          if (image.getAttribute("data-gallery-priority") === "primary") state.primaryReady = true;
        } else {
          if (job) {
            forEach(job.waiters, function (waiter) { setState(waiter, "error", false); });
          } else {
            setState(image, "error", false);
          }
          reportDiagnostic(code);
        }
        state.prioritySettled += 1;
        state.activeCount = Math.max(0, state.activeCount - 1);
        drain(state);
        scheduleWarmup(state);
      }

      function loaded() {
        settleDecode(
          image,
          function () { finish(true, ""); },
          function () { finish(false, "initial-decode-failed"); }
        );
      }

      function failed() {
        finish(false, "initial-request-failed");
      }

      state.priorityCleanups.push(function () {
        image.removeEventListener("load", loaded);
        image.removeEventListener("error", failed);
      });

      setState(image, "requested", false);
      if (image.complete) {
        if (image.naturalWidth > 0) loaded();
        else finish(false, "initial-request-failed");
      } else {
        image.addEventListener("load", loaded, { once: true });
        image.addEventListener("error", failed, { once: true });
      }
    });
    return true;
  }

  function activateByIndex(state, index) {
    var selector = '[data-gallery-image][data-gallery-index="' + String(index) + '"]';
    forEach(state.root.querySelectorAll(selector), function (image) {
      requestImage(state, image, "demand");
    });
  }

  function activateByImageId(state, imageId) {
    forEach(state.root.querySelectorAll(".product-single__photo[data-image-id]"), function (wrapper) {
      if (String(wrapper.getAttribute("data-image-id")) === String(imageId)) {
        forEach(wrapper.querySelectorAll("[data-gallery-image]"), function (image) {
          requestImage(state, image, "demand");
        });
      }
    });
  }

  function activateCurrentSlide(state) {
    var slider = state.root.querySelector(".slider-for");
    var slide;
    if (!slider || typeof slider.querySelector !== "function") return;
    slide = slider.querySelector(".slick-slide.slick-current:not(.slick-cloned)") ||
      slider.querySelector(".slick-slide.slick-current") ||
      slider.querySelector('.slick-slide[aria-hidden="false"]:not(.slick-cloned)') ||
      slider.querySelector('.slick-slide[aria-hidden="false"]');
    if (!slide) return;
    forEach(slide.querySelectorAll("[data-gallery-image]"), function (image) {
      requestImage(state, image, "demand");
    });
  }

  function dotIndex(dot) {
    if (!dot || !dot.parentNode || !dot.parentNode.children) return -1;
    return Array.prototype.indexOf.call(dot.parentNode.children, dot);
  }

  function bindCore(state) {
    var slider = state.root.querySelector(".slider-for");
    state.clickHandler = function (event) {
      var thumbnail = event.target.closest(".product-single__thumbnail[data-thumbnail-id]");
      var dot;
      var index;
      if (thumbnail && state.root.contains(thumbnail)) {
        state.customerInteracted = true;
        cancelWarmup(state);
        activateByImageId(state, thumbnail.getAttribute("data-thumbnail-id"));
        return;
      }
      dot = event.target.closest(".slick-dots li");
      if (!dot || !state.root.contains(dot)) return;
      index = dotIndex(dot);
      if (index >= 0) {
        state.customerInteracted = true;
        cancelWarmup(state);
        activateByIndex(state, index);
      }
    };
    state.root.addEventListener("click", state.clickHandler, true);
    if (slider && typeof window.MutationObserver === "function") {
      state.observer = new window.MutationObserver(function () {
        bindJQuery(state);
        activateCurrentSlide(state);
      });
      state.observer.observe(slider, {
        attributes: true,
        attributeFilter: ["class", "aria-hidden"],
        childList: true,
        subtree: true
      });
    } else if (slider) {
      reportDiagnostic("mutation-observer-unavailable");
    }
  }

  function bindJQuery(state) {
    var $root;
    var $slider;
    if (state.destroyed || state.jqueryBound || typeof window.jQuery !== "function") return false;
    $root = window.jQuery(state.root);
    if (!$root || typeof $root.on !== "function" || typeof $root.off !== "function" || typeof $root.find !== "function") return false;
    $slider = $root.find(".slider-for");
    if (!$slider || typeof $slider.on !== "function" || typeof $slider.off !== "function") return false;
    $root.on("variantImageChange.ninteGalleryV1", function (event) {
      var variant = event.variant;
      if (variant && variant.featured_image && variant.featured_image.id) {
        state.customerInteracted = true;
        cancelWarmup(state);
        activateByImageId(state, variant.featured_image.id);
      }
    });
    $slider.on("beforeChange.ninteGalleryV1", function (event, slick, currentSlide, nextSlide) {
      state.customerInteracted = true;
      cancelWarmup(state);
      activateByIndex(state, nextSlide);
    });
    $slider.on("init.ninteGalleryV1 reInit.ninteGalleryV1", function (event, slick) {
      activateByIndex(state, slick && typeof slick.currentSlide === "number" ? slick.currentSlide : 0);
    });
    state.jqueryBound = true;
    if (state.jqueryRetryTimer !== null) window.clearTimeout(state.jqueryRetryTimer);
    state.jqueryRetryTimer = null;
    return true;
  }

  function scheduleJQueryRetry(state) {
    if (state.destroyed || state.jqueryBound || state.jqueryRetryTimer !== null) return;
    if (state.jqueryRetryCount >= 20) {
      reportDiagnostic("jquery-unavailable");
      return;
    }
    state.jqueryRetryCount += 1;
    state.jqueryRetryTimer = window.setTimeout(function () {
      state.jqueryRetryTimer = null;
      if (!bindJQuery(state)) scheduleJQueryRetry(state);
    }, 100);
  }

  function warmupAllowed(state) {
    var connection = window.navigator && window.navigator.connection;
    var type = connection && connection.effectiveType;
    var count = parseInt(state.root.getAttribute("data-gallery-image-count"), 10);
    return count > 1 && state.priorityTotal === 1 && state.prioritySettled === 1 &&
      state.primaryReady && !state.customerInteracted && !document.hidden && !(connection && connection.saveData === true) &&
      type !== "slow-2g" && type !== "2g";
  }

  function scheduleWarmup(state) {
    var initial;
    var count;
    var target;
    var callback;
    if (!warmupAllowed(state) || state.warmupHandle !== null || state.pendingWarmup) return;
    initial = parseInt(state.root.getAttribute("data-gallery-initial-index"), 10) || 0;
    count = parseInt(state.root.getAttribute("data-gallery-image-count"), 10) || 0;
    target = initial + 1 < count ? initial + 1 : initial - 1;
    if (target < 0) return;
    callback = function () {
      var image;
      state.warmupHandle = null;
      state.warmupKind = null;
      if (!warmupAllowed(state) || state.destroyed) return;
      image = state.root.querySelector('[data-gallery-image][data-gallery-index="' + String(target) + '"]');
      if (image) requestImage(state, image, "warmup");
    };
    if (typeof window.requestIdleCallback === "function") {
      state.warmupKind = "idle";
      state.warmupHandle = window.requestIdleCallback(callback, { timeout: 1600 });
    } else {
      state.warmupKind = "timer";
      state.warmupHandle = window.setTimeout(callback, 350);
    }
  }

  function stateForRoot(root) {
    var match = null;
    forEach(states, function (state) { if (state.root === root && !state.destroyed) match = state; });
    return match;
  }

  function rootsInScope(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches(ROOT_SELECTOR)) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      forEach(scope.querySelectorAll(ROOT_SELECTOR), function (root) {
        if (roots.indexOf(root) === -1) roots.push(root);
      });
    }
    return roots;
  }

  function destroyState(state) {
    var $root;
    var $slider;
    if (!state || state.destroyed) return;
    state.destroyed = true;
    cancelWarmup(state);
    if (state.jqueryRetryTimer !== null) window.clearTimeout(state.jqueryRetryTimer);
    state.jqueryRetryTimer = null;
    if (state.observer) state.observer.disconnect();
    if (state.clickHandler) state.root.removeEventListener("click", state.clickHandler, true);
    forEach(state.priorityCleanups, function (cleanup) { cleanup(); });
    state.priorityCleanups = [];
    if (typeof window.jQuery === "function") {
      $root = window.jQuery(state.root);
      if ($root && typeof $root.off === "function") $root.off(".ninteGalleryV1");
      if ($root && typeof $root.find === "function") {
        $slider = $root.find(".slider-for");
        if ($slider && typeof $slider.off === "function") $slider.off(".ninteGalleryV1");
      }
    }
    forEach(state.requests, function (request) {
      request.waiters = [];
      request.preloader.onload = null;
      request.preloader.onerror = null;
    });
    state.requests = [];
    state.priorityKeys = [];
    state.pendingDemand = null;
    state.pendingWarmup = null;
  }

  function bindRoot(root) {
    var state;
    var imageCount;
    var index;
    if (stateForRoot(root)) return;
    state = createState(root);
    states.push(state);
    if (!trackPriorityImages(state)) {
      destroyState(state);
      index = states.indexOf(state);
      if (index !== -1) states.splice(index, 1);
      return;
    }
    imageCount = parseInt(root.getAttribute("data-gallery-image-count"), 10) || 0;
    if (imageCount <= 1) return;
    bindCore(state);
    if (!bindJQuery(state)) scheduleJQueryRetry(state);
    activateCurrentSlide(state);
  }

  function boot(scope) {
    forEach(rootsInScope(scope), bindRoot);
  }

  function refresh(scope) {
    forEach(rootsInScope(scope), function (root) {
      var state = stateForRoot(root);
      if (state) activateCurrentSlide(state);
    });
  }

  function destroyScope(scope) {
    forEach(rootsInScope(scope), function (root) {
      var state = stateForRoot(root);
      var index;
      if (!state) return;
      destroyState(state);
      index = states.indexOf(state);
      if (index !== -1) states.splice(index, 1);
    });
  }

  function onVisibilityChange() {
    if (!document.hidden) return;
    forEach(states, cancelWarmup);
  }

  function startWhenReady() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () { boot(document); }, { once: true });
    } else {
      boot(document);
    }
  }

  document.addEventListener("shopify:section:load", function (event) { boot(event.target); });
  document.addEventListener("shopify:section:unload", function (event) { destroyScope(event.target); });
  document.addEventListener("visibilitychange", onVisibilityChange);
  window.addEventListener("pageshow", function () { boot(document); refresh(document); });

  var api = {
    version: "1.0.0",
    boot: boot,
    refresh: refresh,
    destroyScope: destroyScope
  };
  if (commonJS) {
    api.sourceKey = sourceKey;
    api.sameImageSource = sameImageSource;
    api.swapReadyImage = swapReadyImage;
  }
  window[GLOBAL_NAME] = api;
  startWhenReady();
  return api;
});
